import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  Optional,
  ViewContainerRef,
} from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

import { tap } from 'rxjs';
import { UserService } from 'src/app/authentication/services/user.service';
import { SubSink } from 'subsink';

import { NoEditRoleComponent } from '../components/no-edit-role/no-edit-role.component';
import { required } from '../decorators/required.decorator';

@Directive({
  selector: '[appEditableWithRole]',
})
export class EditableWithRoleDirective implements OnChanges, OnDestroy {
  @Input() @required appEditableWithRole: string[] | null = [];

  private subs = new SubSink();

  constructor(
    private readonly userService: UserService,
    private readonly elementRef: ElementRef,
    private viewContainerRef: ViewContainerRef,
    @Optional() private readonly formGroupDir?: FormGroupDirective
  ) {}

  ngOnChanges(): void {
    this.checkRoles();
  }

  checkRoles() {
    if (this.appEditableWithRole) {
      this.subs.sink = this.userService
        .hasAnyRole(this.appEditableWithRole)
        .pipe(
          tap((hasAnyRole) => {
            if (!hasAnyRole) {
              this.disableForm();
              this.disableNonFormInputs();
              this.hideAllButtons();
              this.showNoEditRoleComponent();
            }
          })
        )
        .subscribe();
    } else return;
  }

  disableForm() {
    this.formGroupDir?.form.disable();
  }

  disableNonFormInputs() {
    const inputs = this.elementRef.nativeElement.querySelectorAll(
      'input'
    ) as HTMLInputElement[];
    inputs.forEach((input: HTMLInputElement) => {
      input.disabled = true;
    });
  }

  hideAllButtons() {
    const buttons = this.elementRef.nativeElement.querySelectorAll(
      'button'
    ) as HTMLButtonElement[];
    buttons.forEach((button: HTMLButtonElement) => {
      button.disabled = true;
      button.style.visibility = 'hidden';
    });
  }

  showNoEditRoleComponent() {
    const host = this.elementRef.nativeElement;
    const componentRef =
      this.viewContainerRef.createComponent(NoEditRoleComponent);
    host.insertBefore(componentRef.location.nativeElement, host.firstChild);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
